var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inject } from "@angular/core";
import { EncryptStorage, OrganizationVoData } from "../..";
import { ApplicationVisibilityApiData } from "../../end-points-dto/api-dto/application/application-visibility-api-data";
import { OrganizationPolicyData } from "../../end-points-dto/api-dto/organization/organization-policy-data";
import { StorageData } from "../../storage/storage-data";
import { Events } from "ionic-angular";
import { SimpleModel } from "../simpleModel";
import { StorageType } from "../../storage/storage-type";
var OrganizationModel = /** @class */ (function (_super) {
    __extends(OrganizationModel, _super);
    function OrganizationModel(storage, events) {
        var _this = _super.call(this, storage, events, "organization") || this;
        _this.__model = new OrganizationVoData();
        _this.event.URI_CHANGED = _this._keyItem + "-uri:changed";
        _this.event.ID_CHANGED = _this._keyItem + "-id:changed";
        _this.event.STATUSES_CHANGED = _this._keyItem + "-statuses:changed";
        _this.event.ITEM_TYPES_CHANGED = _this._keyItem + "-item-types:changed";
        _this.event.USER_TYPES_CHANGED = _this._keyItem + "-user-types:changed";
        _this.event.APPLICATION_VISIBILITY_CHANGED = _this._keyItem + "-application-visibility:changed";
        _this.event.POLICY_CHANGED = _this._keyItem + "-policy:changed";
        return _this;
    }
    Object.defineProperty(OrganizationModel.prototype, "_model", {
        get: function () {
            return this.__model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationModel.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationModel.prototype.load = function () {
        var _this = this;
        this.storage.load("organization-uri", false).then(function (res) {
            if (res != null)
                _this._uri = res;
        });
        this.storage.load("organization-current-cp-id", false).then(function (res) {
            if (res != null)
                _this._currentCpId = Number(res);
        });
    };
    Object.defineProperty(OrganizationModel.prototype, "id", {
        get: function () {
            return this._model.uid;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationModel.prototype.setId = function (value, preventDefault) {
        this._model.uid = value;
        return this.save(new StorageData(this.event.ID_CHANGED, preventDefault, value));
    };
    Object.defineProperty(OrganizationModel.prototype, "cpId", {
        get: function () {
            return this._currentCpId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationModel.prototype, "CpIdSession", {
        get: function () {
            var cpId = this.storage.load("organization-current-cp-id", false, StorageType.SESSION);
            if (cpId)
                return Number(cpId);
            else
                return null;
        },
        enumerable: true,
        configurable: true
    });
    OrganizationModel.prototype.setCpId = function (value, preventDefault) {
        this._currentCpId = value;
        //this.storage.createLocalDb(String(this._currentCpId));
        var storageData = new StorageData(this.event.CP_ID_CHANGED, preventDefault, value);
        storageData.key = "organization-current-cp-id";
        storageData.item = value;
        storageData.encrypt = false;
        var storageDataSession = new StorageData(this.event.CP_ID_CHANGED, true, value, false, StorageType.SESSION);
        storageDataSession.item = value;
        storageDataSession.key = "organization-current-cp-id";
        storageDataSession.encrypt = false;
        return this.storage.saveAs(storageData) && this.storage.saveAs(storageDataSession);
    };
    Object.defineProperty(OrganizationModel.prototype, "uri", {
        get: function () {
            return this._uri;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationModel.prototype, "uriSession", {
        get: function () {
            return this.storage.load("organization-uri", false, StorageType.SESSION);
        },
        enumerable: true,
        configurable: true
    });
    OrganizationModel.prototype.setUri = function (value, preventDefault) {
        if (value === this._uri)
            return;
        this._uri = value;
        this.storage.createLocalDb(this._uri);
        var storageData = new StorageData(this.event.URI_CHANGED, preventDefault, value);
        storageData.key = "organization-uri";
        storageData.item = value;
        storageData.encrypt = false;
        var storageDataSession = new StorageData(this.event.URI_CHANGED, true, value, false, StorageType.SESSION);
        storageDataSession.item = value;
        storageDataSession.key = "organization-uri";
        storageDataSession.encrypt = false;
        return this.storage.saveAs(storageData) && this.storage.saveAs(storageDataSession);
    };
    OrganizationModel.prototype.setStatuses = function (value, preventDefault) {
        this._model.statuses = value;
        return this.save(new StorageData(this.event.STATUSES_CHANGED, preventDefault, value));
    };
    OrganizationModel.prototype.setItemTypes = function (value, preventDefault) {
        this._model.itemTypes = value;
        return this.save(new StorageData(this.event.ITEM_TYPES_CHANGED, preventDefault, value));
    };
    OrganizationModel.prototype.setUserTypes = function (value, preventDefault) {
        this._model.userTypes = value;
        return this.save(new StorageData(this.event.USER_TYPES_CHANGED, preventDefault, value));
    };
    OrganizationModel.prototype.setApplicationVisibility = function (value, preventDefault) {
        this._model.applicationVisibility = value;
        return this.save(new StorageData(this.event.APPLICATION_VISIBILITY_CHANGED, preventDefault, value));
    };
    OrganizationModel.prototype.setPolicy = function (value, preventDefault) {
        this._model.policy = value;
        return this.save(new StorageData(this.event.POLICY_CHANGED, preventDefault, value));
    };
    OrganizationModel.prototype.getItemsType = function () {
        return this._model.itemTypes;
    };
    OrganizationModel.prototype.clear = function (preventDefault, preventSave) {
        this._model.uid = null;
        this._model.statuses = [];
        this._model.itemTypes = [];
        this._model.userTypes = [];
        this._model.applicationVisibility = new ApplicationVisibilityApiData();
        this._model.policy = new OrganizationPolicyData();
        var storageData = new StorageData(this.event.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    OrganizationModel.prototype.clone = function () {
        var clone = new OrganizationVoData();
        clone.uid = this._model.uid;
        clone.statuses = this._model.statuses;
        clone.itemTypes = this._model.itemTypes;
        clone.userTypes = this._model.userTypes;
        clone.applicationVisibility = this._model.applicationVisibility;
        clone.policy = this._model.policy;
        return clone;
    };
    /** @nocollapse */
    OrganizationModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return OrganizationModel;
}(SimpleModel));
export { OrganizationModel };
//# sourceMappingURL=organization-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/organization/organization-model.js
// module id = 355
// module chunks = 14